import React, { useEffect } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  type?: 'success' | 'error' | 'info';
}
export const Toast: React.FC<ToastProps> = ({
  message,
  isVisible,
  onClose,
  type = 'success'
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  return <div className="fixed top-20 right-4 z-50 animate-fade-in" data-id="element-324">
      <div className="w-full md:w-96 bg-white shadow-lg rounded-lg pointer-events-auto overflow-hidden border border-gray-100" data-id="element-325">
        <div className="p-4" data-id="element-326">
          <div className="flex items-center" data-id="element-327">
            <div className="flex-shrink-0" data-id="element-328">
              {type === 'success' && <CheckCircleIcon className="h-6 w-6 text-green-500" aria-hidden="true" data-id="element-329" />}
            </div>
            <div className="ml-3 flex-1" data-id="element-330">
              <p className="text-sm font-medium text-gray-900" data-id="element-331">{message}</p>
            </div>
            <div className="ml-4 flex-shrink-0" data-id="element-332">
              <button className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500" onClick={onClose} data-id="element-333">
                <span className="sr-only" data-id="element-334">Close</span>
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-335" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};